import customersSlice from './customers/customersSlice';
import destPointSlice from './destPoint/destPointSlice';
import driversSlice from './drivers/driversSlice';
import productsSlice from './products/productsSlice';
import resultsSlice from './results/resultsSlice';
import { settingsActions } from './settings/settingsSlice';
import vehiclesSlice from './vehicles/vehiclesSlice';
import weightingsSlice from './weightings/weightingsSlice';

const reduxSlicesList = {
 results: resultsSlice.actions,
 customers: customersSlice.actions,
 drivers: driversSlice.actions,
 vehicles: vehiclesSlice.actions,
 weightings: weightingsSlice.actions,
 products: productsSlice.actions,
 destPoint: destPointSlice.actions,
 settings: settingsActions,
};

export default reduxSlicesList;
